import React from 'react';
import ContentLoader from 'react-content-loader';
import { down, up } from 'styled-breakpoints';
import styled from 'styled-components';

const OrderPlaceholder = () => (
  <>
    <MobilePlaceholder>
      <ContentLoaderWrapper height="416" width="100%">
        <rect x="0" y="0" rx="5" ry="5" height="35" width="240" />

        <rect x="0" y="60" rx="5" ry="5" height="20" width="140" />
        <rect x="0" y="95" rx="5" ry="5" height="20" width="160" />
        <rect x="0" y="160" rx="5" ry="5" height="20" width="140" />
        <rect x="0" y="195" rx="5" ry="5" height="20" width="160" />

        <rect x="0" y="250" rx="5" ry="5" height="30" width="240" />
        <rect x="0" y="290" rx="5" ry="5" height="240" width="240" />
        <rect x="260" y="290" rx="5" ry="5" height="240" width="240" />

        <rect x="0" y="550" height="42" width="600" />
        <rect x="0" y="605" height="42" width="600" />
      </ContentLoaderWrapper>
    </MobilePlaceholder>
    <TabletPlaceholder>
      <ContentLoaderWrapper height="416" width="100%">
        <rect x="0" y="0" rx="5" ry="5" height="35" width="240" />

        <rect x="0" y="60" rx="5" ry="5" height="20" width="140" />
        <rect x="240" y="60" rx="5" ry="5" height="20" width="140" />
        <rect x="0" y="95" rx="5" ry="5" height="20" width="160" />
        <rect x="240" y="95" rx="5" ry="5" height="20" width="300" />

        <rect x="0" y="150" rx="5" ry="5" height="30" width="240" />
        <rect x="0" y="190" rx="5" ry="5" height="150" width="150" />
        <rect x="170" y="190" rx="5" ry="5" height="150" width="150" />
        <rect x="340" y="190" rx="5" ry="5" height="150" width="150" />
        <rect x="510" y="190" rx="5" ry="5" height="150" width="150" />

        <rect x="0" y="350" rx="5" ry="5" height="15" width="140" />
        <rect x="0" y="380" rx="5" ry="5" height="10" width="140" />
        <rect x="0" y="395" rx="5" ry="5" height="10" width="140" />
        <rect x="170" y="350" rx="5" ry="5" height="15" width="140" />
        <rect x="170" y="380" rx="5" ry="5" height="10" width="140" />
        <rect x="170" y="395" rx="5" ry="5" height="10" width="140" />
        <rect x="340" y="350" rx="5" ry="5" height="15" width="140" />
        <rect x="340" y="380" rx="5" ry="5" height="10" width="140" />
        <rect x="340" y="395" rx="5" ry="5" height="10" width="140" />
        <rect x="510" y="350" rx="5" ry="5" height="15" width="140" />
        <rect x="510" y="380" rx="5" ry="5" height="10" width="140" />
        <rect x="510" y="395" rx="5" ry="5" height="10" width="140" />
      </ContentLoaderWrapper>
      <ButtonPlaceholder>
        <rect x="0" y="0" rx="5" ry="5" height="42" width="170" />
      </ButtonPlaceholder>
    </TabletPlaceholder>
    <DesktopPlaceholder>
      <ContentLoaderWrapper height="416" width="100%">
        <rect x="0" y="0" rx="5" ry="5" height="35" width="240" />

        <rect x="0" y="60" rx="5" ry="5" height="20" width="140" />
        <rect x="240" y="60" rx="5" ry="5" height="20" width="140" />
        <rect x="0" y="95" rx="5" ry="5" height="20" width="160" />
        <rect x="240" y="95" rx="5" ry="5" height="20" width="300" />

        <rect x="0" y="150" rx="5" ry="5" height="30" width="240" />
        <rect x="0" y="190" rx="5" ry="5" height="150" width="150" />
        <rect x="170" y="190" rx="5" ry="5" height="150" width="150" />
        <rect x="340" y="190" rx="5" ry="5" height="150" width="150" />
        <rect x="510" y="190" rx="5" ry="5" height="150" width="150" />
        <rect x="0" y="350" rx="5" ry="5" height="15" width="140" />
        <rect x="170" y="350" rx="5" ry="5" height="15" width="140" />
        <rect x="340" y="350" rx="5" ry="5" height="15" width="140" />
        <rect x="510" y="350" rx="5" ry="5" height="15" width="140" />
      </ContentLoaderWrapper>
      <ButtonPlaceholder>
        <rect x="0" y="0" rx="5" ry="5" height="42" width="170" />
      </ButtonPlaceholder>
    </DesktopPlaceholder>
  </>
);

const ButtonPlaceholder = styled(ContentLoader)`
  width: 170px;
  height: 42px;
  position: absolute;
  right: 16px;
  top: 24px;
`;

const ContentLoaderWrapper = styled(ContentLoader)`
  height: 700px;
  border: 1px solid ${(props) => props.theme.colors.grayLight3};
  border-radius: 12px;
  padding: 24px 16px;
  box-sizing: border-box;

  ${up('sm')} {
    height: 457px;
  }

  ${up('md')} {
    height: 416px;
  }
`;

const MobilePlaceholder = styled.div`
  margin-bottom: 20px;

  ${up('sm')} {
    display: none;
  }
`;

const TabletPlaceholder = styled.div`
  margin-bottom: 36px;
  position: relative;

  ${down('xs')} {
    display: none;
  }

  ${up('lg')} {
    display: none;
  }
`;

const DesktopPlaceholder = styled.div`
  margin-bottom: 36px;
  position: relative;

  ${down('md')} {
    display: none;
  }
`;

export default OrderPlaceholder;
